import { Link } from 'react-router-dom';
import { guideArticles } from '@/mocks/articles';

export default function ArticlesSection() {
  return (
    <section id="articles" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold tracking-wide uppercase mb-3">
              SEO Guides
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
              Kakobuy Spreadsheet
            </h2>
            <p className="font-heading text-3xl md:text-4xl font-bold text-primary-600 italic">
              In-Depth Guides
            </p>
            <p className="text-sm text-foreground-500 mt-3 max-w-lg leading-relaxed">
              Explore our collection of detailed <strong>kakobuy spreadsheet</strong> guides covering every product category, safety best practices, and seller comparison frameworks.
            </p>
          </div>
          <span className="whitespace-nowrap px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold">
            9 Expert Guides
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {guideArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/guide/${article.slug}`}
              className="group rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 transition-all duration-300 hover:border-primary-200 cursor-pointer"
            >
              <div className="w-full h-[200px] overflow-hidden">
                <img
                  src={article.heroImage}
                  alt={article.title}
                  title={`${article.title} - Kakobuy Spreadsheet`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-2">
                  {article.category}
                </span>
                <h3 className="font-heading font-semibold text-foreground-900 text-base leading-snug mb-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {article.subtitle}
                </p>
                <div className="flex items-center gap-1 mt-3 text-primary-600 text-xs font-medium">
                  <span>Read Guide</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-xs text-foreground-500 mb-4">
            Each guide is independently researched and updated regularly for accuracy.
          </p>
          <Link
            to="/kakobuy-spreadsheet-beginners-guide"
            className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full border border-foreground-300 text-sm font-medium text-foreground-700 hover:bg-foreground-900 hover:text-background-50 hover:border-foreground-900 transition-all duration-200 cursor-pointer"
          >
            Read the Beginner&apos;s Guide
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}